module.exports = __webpack_public_path__ + "static/media/sisteryusra.9eff3ff9.jpg";